module.exports = __webpack_public_path__ + "static/media/covid_qr_p1_2_mobile.42a8bc10.png";